var map = {
	"./3win8.png": "b82d",
	"./404error.png": "a982",
	"./918kiss.png": "bc88",
	"./BSN.png": "f4a8",
	"./CIMB.png": "3cf4",
	"./CN.png": "253e",
	"./Islam.png": "3647",
	"./MY.png": "b60b",
	"./RHB.png": "e767",
	"./Standard-Chartered.png": "ffcb",
	"./TH.png": "413d",
	"./UK.png": "cfbf",
	"./UOB.png": "3ebb",
	"./Webot-Logo.png": "5bc9",
	"./ambank.png": "ceb3",
	"./c88-logo.png": "a17f",
	"./call-center-agent.png": "8558",
	"./coming-soon.png": "e6d0",
	"./download.png": "f6f5",
	"./internet.png": "8170",
	"./logo.png": "cf05",
	"./may.png": "933d",
	"./maybank.png": "3aa5",
	"./placeholder.png": "5b4d",
	"./pwa_icon.png": "9c2c",
	"./scr888.png": "02db",
	"./wallet.png": "0131"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";